import PageHeader from "app/shared/PageHeader";
import "./Flights.scss";
import CustomReconTabs from "../Reconcilation/components/CustomReconTabs";
import { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { colorPicker } from "app/utils/color.helper";
import {
  tabViewStates,
  userInfo,
  activeTabAtom,
} from "app/config/States/users";
import posthog from "posthog-js";
import { Button, Dropdown, Input, message, Modal, Tabs } from "antd";

import { apiPost } from "app/services/apiServices";

import Loader from "app/shared/Loader";
import FlightDashboard from "./components/FlightDashboard";
import FlightRecon from "./components/FlightRecon";
import FlightReports from "./components/FlightReports";
import UnReconciledFlight from "../AppTour/components/OnboardUnReconcilied/UnReconciledFlight";
import TableViewManager from "app/shared/TableViewManager";
import ReportHistory from "./components/ReportsHistory";
import { API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST } from "../Reconcilation/reconcilation.constants";
import { API_ENDPOINT_AG_TABLE_SAVE_VIEW } from "app/shared/AgTable/AgTable.constants";
import { useFetcher } from "react-router-dom";
import EmptyState from "app/shared/EmptyState";
import { agTableRowSize } from "app/config/States/agtable";
import { appMetaConfig } from "global.constants";
import { getSubdomain } from "app/utils/generic.helper";
import BulkDownloadWidget from "app/shared/BulkDownloadWidget";
import { Mixpanel } from "app/config/Mixpanel";

import DemoPage from "./Demo";
import { FinkAnalytics } from "app/utils/GoogleAnalytics";
import SendReminderModal from "./components/sendReminderModal";
import { BellOutlined } from "@ant-design/icons";
import { tableSchema,activeTableNameState } from "app/config/States/agtable";
import { serverModeState } from "app/config/States/users";
import { set } from "lodash";

export default function Flights(props: any) {
  const [activeTab, setActiveTab] = useRecoilState(activeTabAtom);
  const [useServer, setUseServer] = useRecoilState(serverModeState)
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const reconPageRef: any = useRef();
  const gridRef: any = useRef();
  const [showModal, setShowModal] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [creatingRequest, setCreatingRequest] = useState(false);
  const [showModelFor, setShowModalFor] = useState("");
  const [reportName, setReportName] = useState("");
  const [tableRowSize, setTableRowSize] = useRecoilState<any>(agTableRowSize);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const domain = getSubdomain();
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [tableSchemaInfo] = useRecoilState<any>(tableSchema);
  const [invoiceNumberColumn, setInvoiceNumberColumn] = useState<any>(null);
  const [activeTableName, setActiveTableName] = useRecoilState(activeTableNameState);



  useEffect(() => {
    posthog.capture("test_event_manual", {
      property: "value",
      timestamp: new Date().toISOString(),
    });
  }, []);


  useEffect(() => {
    if (!userDetails || !userDetails.currentWorkspace) return;

    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0];
    const belongsToPortal = subdomain !== "finkraft" ? "yes" : "no";

    FinkAnalytics("user_landed_flights", {
      event_category: "navigation",
      subdomain: subdomain,
      workspace_name: userDetails?.currentWorkspace?.name || "unknown",
      belongs_to_portal: belongsToPortal,
      access_date: new Date().toISOString().split("T")[0],
    });

    FinkAnalytics("navbar_option_clicked", {
      option_name: "Flights",
      workspace_name: userDetails?.currentWorkspace?.name,
      subdomain: window.location.hostname.split(".")[0],
    });

    posthog.capture("test_event_manual", {
      user_id: userDetails.id,
      workspace: userDetails.currentWorkspace?.name,
      subdomain,
      accessed_from_portal: belongsToPortal,
      access_date: new Date().toISOString().split("T")[0],
    });
  }, [userDetails]);

  useEffect(() => {
    if (showModal && showModelFor === "CREATE") {
      FinkAnalytics("user_opened_download_report_modal", {
        event_category: "modal",
        event_label: "Download Report Modal",
        modal_type: "CREATE",
      });
    }
  }, [showModal, showModelFor]);

  useEffect(() => {
    Mixpanel.track("User Landed On Flight Recon", { Screen: "Flight Recon" });
    if (domain === "newdemo") {
      setActiveTab("1");
      return;
    }
    if (
      activeTab === "1" &&
      userDetails?.currentWorkspace?.name !== "MMT Admin"
    ) {
      setActiveTab("2");
    }
  }, [userDetails?.currentWorkspace]);

  const getSceneItems = () => {
    if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) {
      return [{ key: "0", label: "Reconciliation", moduleId: "AIRLINE_RECON_MMT", tableName: "", uniqueId: "AIRLINE_RECON_MMT" }];
    }

    const flightModules = tableSchemaInfo.filter(
      (schema: any) => schema.reportType === "AIRLINE"
    );

    const tabs = flightModules.map((schema: any, index) => {

      return {
        key: index.toString(),  
        label: schema.tabName || schema.label || schema.moduleId,
        moduleId: schema.moduleId,
        tableName: schema.table_name,
        uniqueId: schema.tableName && schema.tableName.trim() !== ''
          ? schema.tableName
          : `${schema.moduleId}_${index}`, 
      };
    });
    console.log(tabs, "tabs in flights");

    return tabs;
  };



  const renderScene = () => {
    switch (activeTab) {
      case "1":
        return <FlightDashboard />;
      case "3":
        return <FlightReports />;
      case "4":
        return (
          <UnReconciledFlight
            singleWorkspace={userDetails?.currentWorkspace?.name !== "MMT Admin"}
          />
        );
      default:
        return (
          <FlightRecon
            ref={reconPageRef}
            moduleId={activeTab}
            onSelectionChanged={(rows: any[]) => setSelectedRows(rows)}
          />
        );
    }
  };

  // useEffect(() => {
  //   const tabs = getSceneItems();
  //   if (tabs.length > 0) {
  //     const activeTabExists = tabs.some(tab => tab.uniqueId === activeTab);
  //     if (!activeTab || !activeTabExists) {
  //       setActiveTab(tabs[0].uniqueId);
  //     }
  //   }
  // }, [tableSchemaInfo, activeTab]);
  useEffect(() => {
    const tabs = getSceneItems();
    if (tabs.length > 0) {
      const activeTabExists = tabs.some(tab => tab.uniqueId === activeTab);
      let nextTabId = activeTab;
  
      if (!activeTab || !activeTabExists) {
        nextTabId = tabs[0].uniqueId;
        setActiveTab(nextTabId);
      }
  
      // Find the matching tab in tabs array instead of tableSchemaInfo
      const activeTabObj = tabs.find(tab => tab.uniqueId === nextTabId);
      console.log(activeTabObj, "activeTabObj in flights")
      if (activeTabObj?.tableName) {
        setActiveTableName(activeTabObj.tableName);
      }
    }
  }, [tableSchemaInfo, activeTab, setActiveTableName]);
  



  const handleRaiseReportRequest = async () => {
    setCreatingRequest(true);
    let backupPayload = {
      startRow: 0,
      endRow: 100,
      rowGroupCols: [],
      valueCols: [],
      pivotCols: [],
      pivotMode: false,
      groupKeys: [],
      filterModel: {},
      sortModel: [],
    };
    let payloadFromTable =
      (await reconPageRef.current) && reconPageRef.current?.getGridState();
    let tablePayload = payloadFromTable || backupPayload;

    const moduleId = (() => {
      if (activeTab.includes('_')) {
        const parts = activeTab.split('_');
        return parts.slice(0, -1).join('_');
      }
      return activeTab;
    })();

    const tableName = (() => {
      const schema = tableSchemaInfo?.find((item: any) =>
        item.moduleId === moduleId ||
        item.table_name === activeTab ||
        (activeTab.includes('_') && item.moduleId === activeTab.split('_').slice(0, -1).join('_'))
      );
      if (schema?.table_name) {
        return schema.table_name;
      }
      if (activeTab.includes('_')) {
        return activeTab.toLowerCase();
      }
      return appMetaConfig[domain]?.flight_recon_table;
    })();

    let payload = {
      moduleId,
      table_name: tableName,
      name: reportName,
      email: userDetails?.email,
      type: "AIRLINE",
      tablePayload: tablePayload,
      workspaceid:
        userDetails.currentWorkspace?.id ||
        localStorage.getItem("currentWorkspace"),
    };

    const response = await apiPost(
      API_ENDPOINT_RECONCILATION_RAISE_RECON_REQUEST,
      payload
    );
    if (response.status) {
      messageApi.success({
        type: "success",
        // content: "We will notify you via email once report is ready",
        content: response.data,
      });
    }
    setCreatingRequest(false);
    setShowModal(false);
    setShowModalFor("");
    setReportName("");
  };
  const handleViewReports = async (report: any) => {
    if (report.key === "1") {
      reconPageRef.current && reconPageRef.current.exportDataToExcel();
      // setShowModalFor("CREATE");
      Mixpanel.track("User Downloaded Flight Recon Table View Report", {
        event_action_type: "REPORT_DOWNLOAD",
        report_type: "Detailed Report",
      });
      return;
    } else {
      setShowModalFor("HISTORY");
      setShowModal(true);
    }
  };

  const handleSend = () => {
    message.success("Reminders will be sent to airline");
    setShowReminderModal(false);
  };
  // useEffect(() => {
  //   // if (!tableSchemaInfo || !activeTab) return;
    
  //   const moduleId = activeTab.includes('_') 
  //     ? activeTab.split('_').slice(0, -1).join('_')
  //     : activeTab;
    
    
  //   const schema = tableSchemaInfo.find((item: any) => item.moduleId === moduleId);
  //   const columnMapping = schema?.column_mapping || null;
  
  //   if (columnMapping) {
  //     const invoiceColumn = columnMapping.find(
  //       (col: any) => col.column_type === "INVOICE_NUMBER"
  //     );
  //     setInvoiceNumberColumn(invoiceColumn?.destination_key || "");
  //   } else {
  //     setInvoiceNumberColumn("");
  //   }
  // }, [tableSchemaInfo, activeTab]);


  useEffect(() => {
    const moduleId = activeTab.includes('_') 
      ? activeTab.split('_').slice(0, -1).join('_')
      : activeTab;
  
    const schema = tableSchemaInfo?.find((item: any) => item.moduleId === moduleId);
    const columnMapping = schema?.column_mapping || null;
  
    if (columnMapping) {
      const invoiceColumns = columnMapping
        .filter((col: any) => col.column_type === "INVOICE_NUMBER")
        .map((col: any) => col.destination_key);
  
  
      setInvoiceNumberColumn(invoiceColumns);
    } else {
      setInvoiceNumberColumn([]);
    }
  }, [tableSchemaInfo, activeTab]);

  console.log("Invoice Number Column State:", invoiceNumberColumn);



  return (
    <div className="Flights">
      <div className="ScreenContainer">
        <PageHeader
          leftActions={
            <Tabs
              items={getSceneItems()}
              tabBarStyle={{ borderBottom: "none", margin: 0 }}
              activeKey={(() => {
                const tabs = getSceneItems();
                const activeIndex = tabs.findIndex(tab => tab.uniqueId === activeTab);
                return activeIndex >= 0 ? activeIndex.toString() : (tabs.length > 0 ? "0" : "");
              })()}
              onChange={(tabKey: string) => {
                const tabs = getSceneItems();
                const selectedTab = tabs.find((t) => t.key === tabKey);
                if (selectedTab) {
                  setActiveTab(selectedTab.uniqueId);
                }
              }}
            />
          }
          rightActions={
            domain !== "newdemo" ? (
              <div style={{ display: "flex", alignItems: "center" }}>

                <TableViewManager
                  moduleId={(() => {
                    if (activeTab.includes('_')) {
                      const parts = activeTab.split('_');
                      return parts.slice(0, -1).join('_'); // Get moduleId part
                    }
                    return activeTab;
                  })()}
                  createView={async (viewName: string) => {

                    const moduleId = (() => {
                      if (activeTab.includes('_')) {
                        const parts = activeTab.split('_');
                        return parts.slice(0, -1).join('_');
                      }
                      return activeTab;
                    }
                    )();
                    return reconPageRef.current?.createNewView(viewName, moduleId);
                  }}
                  selectView={(viewId: string) => {
                    setUseServer(true); 
                    setTimeout(() => {
                      if (reconPageRef.current) {
                        if (reconPageRef.current.loadTableView) {
                          reconPageRef.current.loadTableView(viewId);
                        } else {
                        }
                      }
                    }, 0);
                  }}
                  updateView={(viewId: string) => {
                    const moduleId = (() => {
                      if (activeTab.includes('_')) {
                        const parts = activeTab.split('_');
                        return parts.slice(0, -1).join('_');
                      }
                      return activeTab;
                    })();
                    reconPageRef.current &&
                      reconPageRef.current.updateTableView(viewId, moduleId)
                  }
                  }
                />
                {selectedRows.length > 0 &&
                  userDetails?.currentWorkspace?.name === "MCKINSEY & COMPANY INC" && (
                    <Button
                      type="primary"
                      size="small"
                      style={{ marginLeft: 12, marginRight: 12 }}
                      onClick={() => {
                        setShowReminderModal(true);
                      }}
                    >
                      Send Reminder <BellOutlined />
                    </Button>
                  )}
                <div style={{ marginRight: 12, marginLeft: 12 }}>
                  <BulkDownloadWidget
                    getPayload={() =>
                      reconPageRef.current?.getGridState?.() || {}
                    }
                    getColumnDefs={() =>
                      reconPageRef.current?.getAllColumns?.() || []
                    }
                    moduleId={(() => {
                      if (activeTab.includes('_')) {
                        const parts = activeTab.split('_');
                        return parts.slice(0, -1).join('_'); // Get moduleId part
                      }
                      return activeTab;
                    })()}
                    tableName={(() => {
                      const moduleId = activeTab.includes('_')
                        ? activeTab.split('_').slice(0, -1).join('_')
                        : activeTab;

                      const schema = tableSchemaInfo?.find((item: any) =>
                        item.moduleId === moduleId ||
                        item.table_name === activeTab ||
                        (activeTab.includes('_') && item.moduleId === activeTab.split('_').slice(0, -1).join('_'))
                      );

                      if (schema?.table_name) {
                        return schema.table_name;
                      }

                      if (activeTab.includes('_')) {
                        return activeTab.toLowerCase();
                      }

                      return appMetaConfig[domain]?.flight_recon_table;
                    })()}
                    
                    success={() => setShowModal(false)}
                    invoiceNumberColumn={invoiceNumberColumn}
                  />
                </div>

                <Dropdown.Button
                  onClick={() => {
                    setShowModalFor("CREATE");
                    setShowModal(true);
                    setUseServer(true);

                    FinkAnalytics("user_opened_download_report_modal", {
                      event_category: "modal",
                      event_label: "Download Report Modal",
                      modal_type: "CREATE",
                    });
                  }}
                  menu={{
                    items: [
                      { key: "1", label: "Download Current Table" },
                      { key: "2", label: "Reports Export History" },
                    ],
                    onClick: handleViewReports,
                  }}
                  size="small"
                  style={{ marginLeft: 12 }}
                  type="primary"
                >
                  Download Report
                </Dropdown.Button>

                <div style={{ marginRight: 12, marginLeft: 12 }}>
                  <BulkDownloadWidget
                    getPayload={() =>
                      reconPageRef.current?.getGridState?.() || {}
                    }
                    getColumnDefs={() =>
                      reconPageRef.current?.getAllColumns?.() || []
                    }
                    moduleId={(() => {
                      if (activeTab.includes('_')) {
                        const parts = activeTab.split('_');
                        return parts.slice(0, -1).join('_'); // Get moduleId part
                      }
                      return activeTab;
                    })()}
                    tableName={(() => {
                      const moduleId = activeTab.includes('_')
                        ? activeTab.split('_').slice(0, -1).join('_')
                        : activeTab;

                      const schema = tableSchemaInfo?.find((item: any) =>
                        item.moduleId === moduleId ||
                        item.table_name === activeTab ||
                        (activeTab.includes('_') && item.moduleId === activeTab.split('_').slice(0, -1).join('_'))
                      );

                      if (schema?.table_name) {
                        return schema.table_name;
                      }

                      if (activeTab.includes('_')) {
                        return activeTab.toLowerCase();
                      }

                      return appMetaConfig[domain]?.flight_recon_table;
                    })()}
                    success={() => setShowModal(false)}
                    type="CSV"
                    invoiceNumberColumn={invoiceNumberColumn}
                  />
                </div>


                <SendReminderModal
                  visible={showReminderModal}
                  onClose={() => setShowReminderModal(false)}
                  onSend={handleSend}
                />
              </div>
            ) : null
          }
        />

        <div className="TableContainer">
          {domain === "newdemo" ? (
            <DemoPage activeTab={activeTab} />
          ) : userDetails.approval_status === "ALLOWED" ? (
            renderScene()
          ) : userDetails.currentWorkspace?.approval_status === "PENDING" ? (
            <EmptyState
              title="Need Approval From Client"
              description="Please check if you have added user from this workspace for acknowledgment"
            />
          ) : (
            renderScene()
          )}
        </div>

        <Modal
          open={showModal}
          footer={false}
          onCancel={() => setShowModal(false)}
          //className="custom-modal"

          title={
            showModelFor === "CREATE"
              ? "Create Report Request"
              : "Report Download History"
          }
          className={showModelFor === "CREATE" ? " " : "custom-modal"}
          width={showModelFor === "CREATE" ? 500 : 800}
        >
          {showModelFor === "CREATE" ? (
            <>
              <Input
                placeholder="Report Name"
                onChange={(e: any) => setReportName(e.target.value)}
                value={reportName}
              />
              <div
                style={{
                  marginTop: 12,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  style={{ marginRight: 12 }}
                  onClick={() => setShowModal(false)}
                  loading={creatingRequest}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    FinkAnalytics("user_clicked_create_report_request", {
                      event_category: "button_click",
                      event_label: "Create Report Request",
                      modal_type: "CREATE",
                      user_id: userDetails.id,
                      user_identifier:
                        userDetails.id || userDetails.email.split("@")[0],
                      user_name: userDetails.name,
                      user_email: userDetails.email,
                      access_time: new Date().toISOString(),
                    });

                    handleRaiseReportRequest();
                  }}
                  type="primary"
                  loading={creatingRequest}
                >
                  Create
                </Button>
              </div>
            </>
          ) : (
            <ReportHistory
              moduleId={(() => {
                if (domain === "app") {
                  return "AIRLINE_RECON_MMT";
                }
                // Extract moduleId from activeTab for other domains
                if (activeTab.includes('_')) {
                  const parts = activeTab.split('_');
                  return parts.slice(0, -1).join('_'); // Get moduleId part
                }
                return activeTab;
              })()}
            />
          )}
        </Modal>
      </div>
      {contextHolder}
    </div>
  );
}